import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import PlayerVideo from "../../../features/Players/Conteudos/Video";
import PlayerAudio from "../../../features/Players/Conteudos/Audio";
import PlayerPagina from "../../../features/Players/Conteudos/Pagina";
import PlayerPdf from "../../../features/Players/Conteudos/Pdf";
import PlayerQuestionarioDirigido from "../../../features/Players/Conteudos/QuestionarioDirigido/Questionario";
import PlayerQuestionarioDirigidoResumo from "../../../features/Players/Conteudos/QuestionarioDirigido/Resumo";
import PlayerQuestionario from "../../../features/Players/Conteudos/Questionario/Questionario";
import PlayerQuestionarioResumo from "../../../features/Players/Conteudos/Questionario/Resumo";
import PlayerQuestionarioResolucao from "../../../features/Players/Conteudos/QuestionarioResolucao/Resolucao";
import PlayerAvaliacao from "../../../features/Players/Conteudos/Avaliacao/Avaliacao";
import PlayerAvaliacaoResumo from "../../../features/Players/Conteudos/Avaliacao/Resumo";
import PlayerAvaliacaoResolucao from "../../../features/Players/Conteudos/AvaliacaoResolucao/Resolucao";
import PlayerQuestionarioProgresso from "../../../features/Players/Conteudos/QuestionarioProgresso/Questionario";
import PlayerQuestionarioProgressoResumo from "../../../features/Players/Conteudos/QuestionarioProgresso/Resumo";
import PlayerDownload from "../../../features/Players/Conteudos/Download";
import PlayerTrabalho from "../../../features/Players/Conteudos/Trabalho/Trabalho";
import PlayerLink from "../../../features/Players/Conteudos/Link";
//import PlayerSessaoOnline from "./SessaoOnline";
import PlayerSumario from "../../../features/Players/Conteudos/Sumario";
import PlayerSessaoPresencial from "../../../features/Players/Conteudos/SessaoPresencial";
import PlayerAssiduidade from "../../../features/Players/Conteudos/Assiduidade";
import PlayerFicheiro from "../../../GerirCursos/Ficheiros/Pagina";
import PlayerTrabalhoFicheiro from "../../../features/Players/Conteudos/Trabalho/Pagina";
import PlayerJitsiMeeting from "../../../features/Players/Jitsi/JitsiMeeting";
import PlayerJitsiMeetingVideo from "../../../GerirCursos/Videoconferencias/Pagina";
import PlayerJitsiMeetingGeral from "../../../features/Players/Jitsi/JitsiMeetingGeral";
import PlayerJitsiMeetingWebinar from "../../../features/Players/Jitsi/JitsiMeetingWebinar";
import PlayerJitsiMeetingVideoGeral from "../../../features/Gestao/Videoconferencias/Pagina";
import PlayerVideoSimples from "../../../features/Players/Conteudos/VideoSimples";
import { GlobalContext } from "../../../app/providers/GlobalState";

class PlayerLayout extends Component {
    static contextType = GlobalContext;
    state = {
        //REDIRECT
        redirect: false,
        redirectLink: ""
    };

    componentDidUpdate() {
        //if (!this.context.is_authenticated || this.context.role === "UTILIZADOR") {
        //    if (!this.context.is_authenticated)
        //        this.setState({
        //            redirect: true,
        //            redirectLink: "/login"
        //        });
        //    else if (this.context.role === "UTILIZADOR")
        //        this.setState({
        //            redirect: true,
        //            redirectLink: "/user"
        //        });
        //}

        if (!this.context.is_authenticated) {
            this.setState({
                redirect: true,
                redirectLink: "/login"
            });
        }
    }

    render() {
        const {
            //REDIRECT
            redirect,
            redirectLink
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        return (
            <Switch>
                <Route exact path="/turma-player/:curso/:aula/player-video" component={PlayerVideo} />
                <Route exact path="/turma-player/:curso/:aula/player-audio" component={PlayerAudio} />
                <Route exact path="/turma-player/:curso/:aula/player-pagina" component={PlayerPagina} />
                <Route exact path="/turma-player/:curso/:aula/player-pdf" component={PlayerPdf} />
                <Route exact path="/turma-player/:curso/:aula/player-questionario-dirigido" component={PlayerQuestionarioDirigido} />
                <Route
                    exact
                    path="/turma-player/:curso/:aula/player-questionario-dirigido-resumo"
                    component={PlayerQuestionarioDirigidoResumo}
                />
                <Route exact path="/turma-player/:curso/:aula/player-questionario" component={PlayerQuestionario} />
                <Route exact path="/turma-player/:curso/:aula/player-questionario-resumo" component={PlayerQuestionarioResumo} />
                <Route exact path="/turma-player/:curso/:aula/player-questionario-resolucao" component={PlayerQuestionarioResolucao} />
                <Route exact path="/turma-player/:curso/:aula/player-avaliacao" component={PlayerAvaliacao} />
                <Route exact path="/turma-player/:curso/:aula/player-avaliacao-resumo" component={PlayerAvaliacaoResumo} />
                <Route exact path="/turma-player/:curso/:aula/player-avaliacao-resolucao" component={PlayerAvaliacaoResolucao} />
                <Route exact path="/turma-player/:curso/:aula/player-questionario-progresso" component={PlayerQuestionarioProgresso} />
                <Route
                    exact
                    path="/turma-player/:curso/:aula/player-questionario-progresso-resumo"
                    component={PlayerQuestionarioProgressoResumo}
                />
                <Route exact path="/turma-player/:curso/:aula/player-download" component={PlayerDownload} />
                <Route exact path="/turma-player/:curso/:aula/player-trabalho" component={PlayerTrabalho} />
                <Route exact path="/turma-player/:curso/:aula/player-link" component={PlayerLink} />
                <Route exact path="/turma-player/:curso/:aula/player-sumario" component={PlayerSumario} />
                <Route exact path="/turma-player/:curso/:aula/player-sessao-presencial" component={PlayerSessaoPresencial} />
                <Route exact path="/turma-player/:curso/:aula/player-assiduidade" component={PlayerAssiduidade} />
                <Route exact path="/turma-player/:curso/:ficheiro/player-trabalho-ficheiro" component={PlayerTrabalhoFicheiro} />
                <Route exact path="/turma-player/:curso/:ficheiro/player-ficheiro" component={PlayerFicheiro} />
                <Route exact path="/turma-player/:curso/vconf/:vconfid/player-videoconferencia" component={PlayerJitsiMeeting} />
                <Route exact path="/turma-player/:curso/vconf/:vconfid/player-video" component={PlayerJitsiMeetingVideo} />
            </Switch>
        );
    }
}

export default PlayerLayout;
